const getEnv = (shortName: string, required = true) => {
  const name = `REACT_APP_${shortName}`;
  const value = process.env[name];
  if (required && !value) {
    console.error(
      'Environment Variable not provided!',
      { name, value },
      'Please, set its value in the ".env" file.',
    );
  }
  return value ?? '';
};

export const APP_NAME = getEnv('NAME', false) || 'Trane Maintenance Management (TMM)';
export const GQL = {
  url: getEnv('GQL_URL'),
  region: getEnv('GQL_REGION'),
};

export const COGNITO = {
  authority: getEnv('COGNITO_AUTHORITY'),
  clientId: getEnv('COGNITO_CLIENT_ID'),
  returnUrl: getEnv('COGNITO_RETURN_URL'),
  responseType: getEnv('COGNITO_RESPONSE_TYPE'),
  scope: getEnv('COGNITO_SCOPE'),
  domain: getEnv('COGNITO_DOMAIN'),
};

export const STORAGE = {
  AUTH: 'nuvo-user',
  DASHBOARD: 'nuvo-dashboard',
  CHAT: 'nuvo-chat',
  DATAGRID: 'nuvo-datagrid',
};

export const DEV_MODE = getEnv('DEV_MODE', false) || 'false';

export const NULL_STR = '$null';
export const NULL_LABEL = '';

export const OCR_BASE_URL = getEnv('OCR_BASE_URL');

export const OMIT_FIELDS: string[] = [
  'image',
  'number',
  'displayNumber',
  'createdAt',
  'createdBy',
  'id',
];
